var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar',{attrs:{"title":"部门排名","url":"/sale"}}),_c('div',{staticClass:"rank"},[_c('img',{attrs:{"src":_vm.rank},on:{"click":function($event){return _vm.preview(_vm.rank)}}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }